<template>
  <page-login/>
</template>

<script setup>
import {useI18n} from 'vue-i18n';
const {t} = useI18n();

useHead({
  title: t('login.meta.title', 'Login'),
  meta: [
    {
      name: 'description',
      content: t('login.meta.description', 'Login to your account'),
    },
  ],
});

definePageMeta({
  layout: 'auth',
});
</script>